import React from "react";
import { Box, Image, Tooltip, useRadio } from "@chakra-ui/react";

// One pill in the Home page's level tabs. Styles live in App.scss under .level-tab.
export const LevelCard = (props) => {
  const { getInputProps, getCheckboxProps } = useRadio(props);
  const input = getInputProps();
  const checkbox = getCheckboxProps();
  return (
    <Box as="label" sx={{ position: "relative" }}>
      <input {...input} />
      <Tooltip
        label={
          input.disabled
            ? `Unlock this level when ${props.criteria} questions answered correctly on the previous level.` : ""
        }
        aria-label="level criteria"
      >
        <Box
          {...checkbox}
          className={`level-tab${input.disabled ? " level-tab--locked" : ""}`}
        >
          {input.disabled && (
            <Image
              src="./images/lock.png"
              alt="locked"
              className="level-tab__lock"
            />
          )}
          <Box as="span">{props.children}</Box>
        </Box>
      </Tooltip>
    </Box>
  );
};
